import { Outlet, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShieldOff } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function CareGate() {
  const { user } = useAuth();
  const { t } = useTranslation();
  const nav = useNavigate();
  if ((user?.organization?.industry || "").toUpperCase() === "CARE") return <Outlet />;
  return (
    <div data-testid="feature-not-enabled" className="flex min-h-[50vh] items-center justify-center">
      <div className="card-soft max-w-md p-8 text-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 text-slate-500"><ShieldOff className="h-7 w-7" /></div>
        <h2 className="mt-5 font-heading text-xl font-extrabold text-navy">{t("x.featureNotEnabled")}</h2>
        <button onClick={() => nav("/app/employer")} data-testid="feature-not-enabled-back"
          className="mt-5 w-full rounded-full bg-navy px-4 py-2.5 text-sm font-semibold text-white hover:bg-navy/90">{t("x.backToDashboard")}</button>
      </div>
    </div>
  );
}
